import { v4 as uuidv4 } from 'uuid';
import  { useState, useContext, useEffect } from "react";
import VisitorContext from '../VisitorContext.jsx'
import addIcon from '../../../assets/add.png'
import Popup from 'reactjs-popup';
import useSWR, { preload } from 'swr';
import { localAxios } from '../../../api';
import AddGuardianPopup from './AddGuardian.jsx';

 const AddPopup=()=> { 

    const { addNewVisitor, visitors, editVisitor } = useContext(VisitorContext)

    // From AddVisitor:
    const [visitor, setVisitor] = useState("");
    const [error, setError] = useState(false);

    // From Edit:
    const [visitorFirstName, setVisitorFirstName] = useState("");
    const [visitorLastName, setVisitorLastName] = useState("");
    const [visitorOrgName, setVisitorOrgName] = useState("");
    const [visitorIsMinor, setVisitorIsMinor] = useState(false);
    const [personWillInviteOthers, setPersonWillInviteOthers] = useState(false);
    const [personIsVisitor, setPersonIsVisitor] = useState(true);
    const [personIsGuardian, setPersonIsGuardian] = useState(false);
    
    const [visitorEmail, setVisitorEmail] = useState("");
    const [visitorPhone, setVisitorPhone] = useState("");

    // this is the same as useDefaultValue
    const [userIsGuardian, setUserIsGuardian] = useState(false);

    // These are the states of the four input fields
    const [guardianFirstName, setGuardianFirstName] = useState("");
    const [guardianLastName, setGuardianLastName] = useState("");
    const [guardianEmail, setGuardianEmail] = useState("");
    const [guardianPhone, setGuardianPhone] = useState("");

    const [visitorDeadline, setVisitorDeadline] = useState(formatDateForInput(new Date()));
    const [selectedGuardianId, setSelectedGuardianId] = useState("");
        
    const { data, isLoading, isValidating, mutate } = useSWR('/api/me', localAxios) // undefined but loading even while page mounts

    
    const resetFields = (event) => {
        //Reset all fields so in the list of visitors, one does not have attributes that carry over.
        setVisitorFirstName("");
        setVisitorLastName("");
        setVisitorOrgName("");
        setVisitorIsMinor(false);
        setPersonWillInviteOthers(false);
        setPersonIsVisitor(true);
        setPersonIsGuardian(false);

        setVisitorEmail("");
        setVisitorPhone("");

        // this is the same as useDefaultValue
        setUserIsGuardian(false);

        // Guardian fields
        setGuardianFirstName("");
        setGuardianLastName("");
        setGuardianEmail("");
        setGuardianPhone("");
        setSelectedGuardianId("");
    }

    /*
    function handleChange(e) {
        const { value } = e.target;
        setVisitor(value);
    }
    */

    const handleCheckboxChange = (event) => {
        const isChecked = event.target.checked;
        setUserIsGuardian(isChecked);
    };

    const handleICheckboxChange = (event) => {
        const isChecked = event.target.checked;
        setPersonWillInviteOthers(isChecked);
    };

    const handleGCheckboxChange = (event) => {
        const isChecked = event.target.checked;
        setPersonIsGuardian(isChecked);
    };


    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setError(false);
        }, 1000);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [error]);

    
    useEffect(() => {
        //addItem();
        if (visitorIsMinor) {
            setVisitorEmail('');
            setVisitorPhone('');
            if (userIsGuardian) {
                if (data) {
                    try {
                        setGuardianFirstName(data?.data.first_name || '');
                        setGuardianLastName(data?.data.last_name || '');
                        setGuardianEmail(data?.data.email || '');
                        setGuardianPhone(data?.data.phone || '');
                    } catch (error) {
                        console.log('Inside useEffect. Not able to set vars from data?.data.first_name, which is ',data?.data.first_name)
                    } // try
                } else {
                    console.log('userIsGuardian is ',userIsGuardian,' and data is ',data)
                }
            }
        } else {
            // Clear fields if checkbox is unchecked
            setGuardianFirstName('');
            setGuardianLastName('');
            setGuardianEmail('');
            setGuardianPhone('');
            setVisitorEmail('');
            setVisitorPhone('');
        }
    }, [userIsGuardian, visitorIsMinor]);  // An empty dependency array will run only once-- on mount


    function formatDateForInput(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }


    const handleGuardianSelected = (id) => {
        setSelectedGuardianId(id);
        if (!id) {
            setGuardianFirstName(""); setGuardianLastName("");
            setGuardianEmail(""); setGuardianPhone("");
            return;
        }
        const chosen = visitors.find(v => v.id === id);
        if (chosen) {
            setGuardianFirstName(chosen.visitor_first_name || "");
            setGuardianLastName(chosen.visitor_last_name || "");
            setGuardianEmail(chosen.visitor_email || "");
            setGuardianPhone(chosen.visitor_phone || "");
        }
    };

    const handleGuardianAdded = (newGuardian) => {
        addNewVisitor(newGuardian);
        setSelectedGuardianId(newGuardian.id);
        setGuardianFirstName(newGuardian.visitor_first_name || "");
        setGuardianLastName(newGuardian.visitor_last_name || "");
        setGuardianEmail(newGuardian.visitor_email || "");
        setGuardianPhone(newGuardian.visitor_phone || "");
    };

    // From AddVisitor
    function addItem(close) {
        if (visitorFirstName.length === 0) {
            setError(true);
        } else {

            //handleCheckboxChange(userIsGuardian);

            const newId = uuidv4();
            const currentDate = new Date();
            const deadlineDate = new Date();
            deadlineDate.setDate(currentDate.getDate() + 3); // Default deadline 72 hours from now
            const capitalizedF = visitorFirstName.charAt(0).toUpperCase() + visitorFirstName.slice(1);
            const capitalizedL = visitorLastName.charAt(0).toUpperCase() + visitorLastName.slice(1);
            const capitalizedO = visitorOrgName.charAt(0).toUpperCase() + visitorOrgName.slice(1);

            const emailValidated = visitorEmail;
            const phoneValidated = visitorPhone;

            const capitalizedGF = guardianFirstName.charAt(0).toUpperCase() + guardianFirstName.slice(1);
            const capitalizedGL = guardianLastName.charAt(0).toUpperCase() + guardianLastName.slice(1);

            const gEmailValidated = guardianEmail;
            const gPhoneValidated = guardianPhone;

            addNewVisitor({
                id: newId,
                visitor_first_name: capitalizedF,
                visitor_last_name: capitalizedL,
                visitor_org_name: capitalizedO,

                visitor_is_minor: visitorIsMinor,
                user_is_guardian: userIsGuardian,
                person_will_invite_others: personWillInviteOthers,
                person_is_visitor: visitorIsMinor ? false : personIsVisitor,
                person_is_guardian: personIsGuardian,

                visitor_email: emailValidated,
                visitor_phone: phoneValidated,

                guardian_first_name: capitalizedGF,
                guardian_last_name: capitalizedGL,
                guardian_email: gEmailValidated,
                guardian_phone: gPhoneValidated,

                guardian_id: (visitorIsMinor && !userIsGuardian && selectedGuardianId) ? selectedGuardianId : "",

                createdAt: currentDate,
                deadLine: deadlineDate,
                completed: false,

            });

            if (visitorIsMinor && selectedGuardianId && !userIsGuardian) {
                const guardian = visitors.find(v => v.id === selectedGuardianId);
                if (guardian) {
                    editVisitor({ ...guardian, person_is_guardian: true });
                }
            }

            setVisitor("");
            setError(false);
        }

        resetFields();

        close();
    }

                                                                

    return (
        <Popup trigger={<img className="larger-image" src={addIcon} />} className="popup-content__add" modal nested >
            {close => ( 
                
                <div className="floatBody">
                    <div className="floatSignupForm" >
                        <form action="" className="floatForm">
                            <div className="float-header">Add a {visitorIsMinor ? "minor" : "person"}</div>

                            <div className="float-main">
                                <div className="floatInputContainer">
                                    <input
                                        className="floatInput"
                                        placeholder="a"
                                        type="text"
                                        id="visitorFirstName"
                                        //value={visitorTitle}
                                        onChange={(e) => setVisitorFirstName(e.target.value)}
                                    />
                                    <label htmlFor="visitorFirstName" className="floatLabel">First Name:</label>
                                </div>

                                <div className="floatInputContainer">
                                    <input 
                                        className="floatInput"
                                        placeholder="a"
                                        type="text"
                                        id="visitorLastName"
                                        //value={visitorTitle}
                                        onChange={(e) => setVisitorLastName(e.target.value)}
                                    />
                                    <label htmlFor="visitorLastName" className="floatLabel">Last Name:</label>
                                </div>

                                <div className="floatInputContainer">
                                    <input
                                        className="floatInput"
                                        placeholder="a"
                                        type="text"
                                        id="visitorOrgName"
                                        //value={visitorTitle}
                                        onChange={(e) => setVisitorOrgName(e.target.value)}
                                    />
                                    <label htmlFor="visitorOrgName" className="floatLabel">Organization:</label>
                                </div>

                                <div className="formCheckBox">
                                    <label htmlFor="visitorIsMinor">This person is under 18:</label>
                                    <input
                                        type="checkbox"
                                        id="visitorIsMinor"
                                        checked={visitorIsMinor}
                                        onChange={(e) => setVisitorIsMinor(e.target.checked)}
                                    />
                                </div>


                                {
                                    visitorIsMinor ? (

                                        <>

                                            <div className="formCheckBox">
                                                <label htmlFor="userIsGuardian">I am the guardian:</label>
                                                <input
                                                    type="checkbox"
                                                    id="userIsGuardian"
                                                    checked={userIsGuardian}
                                                    onChange={handleCheckboxChange}
                                                />
                                            </div>

                                            <p>Parent / Guardian</p>

                                            {userIsGuardian ? (
                                                <p style={{ fontSize: '14px', color: '#555' }}>
                                                    Guardian set to: {guardianFirstName} {guardianLastName}
                                                </p>
                                            ) : (
                                                <>
                                                    <div className="floatInputContainer">
                                                        <select
                                                            id="guardianSelect"
                                                            value={selectedGuardianId}
                                                            onChange={(e) => handleGuardianSelected(e.target.value)}
                                                            className="floatInput"
                                                            style={{ paddingTop: '8px' }}
                                                        >
                                                            <option value="">-- Select Guardian --</option>
                                                            {visitors
                                                                .filter(v => !v.visitor_is_minor)
                                                                .map(v => (
                                                                    <option key={v.id} value={v.id}>
                                                                        {v.visitor_first_name} {v.visitor_last_name}
                                                                    </option>
                                                                ))
                                                            }
                                                        </select>
                                                    </div>

                                                    <AddGuardianPopup onGuardianAdded={handleGuardianAdded} />
                                                </>
                                            )}
                                        </>

                                    ) : (
                                        
                                        <>

                                            <div className="formCheckBox">
                                                <label htmlFor="personIsVisitor">This person is a visitor</label>
                                                <input
                                                    type="checkbox"
                                                    id="personIsVisitor"
                                                    checked={personIsVisitor}
                                                    onChange={(e) => setPersonIsVisitor(e.target.checked)}
                                                />
                                            </div>

                                            <div className="formCheckBox">
                                                <label htmlFor="personIsGuardian">This person is a guardian</label>
                                                <input
                                                    type="checkbox"
                                                    id="personIsGuardian"
                                                    checked={personIsGuardian}
                                                    onChange={handleGCheckboxChange}
                                                />
                                            </div>

                                            <div className="formCheckBox">
                                                <label htmlFor="personWillInviteOthers">He / she will invite others</label>
                                                <input
                                                    type="checkbox"
                                                    id="personWillInviteOthers"
                                                    checked={personWillInviteOthers}
                                                    onChange={handleICheckboxChange}
                                                />
                                            </div>

                                            <div className="floatInputContainer">
                                                <input
                                                    className="floatInput"
                                                    placeholder="a"
                                                    type="text"
                                                    id="visitorEmail"
                                                    value={visitorEmail}
                                                    onChange={(e) => !visitorIsMinor && setVisitorEmail(e.target.value)}
                                                />
                                                <label htmlFor="visitorEmail" className="floatLabel">Email:</label>
                                            </div>

                                            <div className="floatInputContainer">
                                                <input
                                                    className="floatInput"
                                                    placeholder="a"
                                                    type="text"
                                                    id="visitorPhone"
                                                    value={visitorPhone}
                                                    onChange={(e) => !visitorIsMinor && setVisitorPhone(e.target.value)}
                                                />
                                                <label htmlFor="visitorPhone" className="floatLabel">Phone:</label>
                                            </div>
                                            
                                        </>

                                    )
                                }
                            </div>

                            <div className="float-footer">
                                <div className="formButtons">
                                    <button className="button save" onClick={() => addItem(close)}>Save</button>
                                    <button className="button cancel"
                                        onClick={() => { close(); }}>Cancel</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                
            )}
        </Popup>
    )
}

export default AddPopup;